"use client";
import React from "react";
import Button from "./button";
import { formatDate, convertDateToStringWithoutTime } from "@/utils";
import { useLocalDate } from "@/utils/hooks/local-date";
interface Option {
  label: string;
  value: Date;
}
export default function DateTabber({
  block,
  value,
  onValueChange,
}: {
  block?: boolean,
  value?: Date;
  onValueChange: (date: Date) => void;
}) {
  const { date: today } = useLocalDate();

  const [currentDate, setCurrentDate] = React.useState<Date | undefined>(undefined);

  const [options, setOptions] = React.useState<Option[] | undefined>(undefined);

  React.useEffect(() => {
    if (value) {
      changeDate(value);
    } else if (currentDate === undefined && today) {
      // if a date hasn't been set yet, but today has been defined,
      // initialize current date and options based on today.
      changeDate(new Date(today));
    }
  }, []);
  React.useEffect(() => {
    
  }, [today]);

  function changeDate(date: Date) {
    if (date === currentDate) {
      return;
    }
    let nextDate = new Date(date.getTime());
    let prevDate = new Date(date.getTime());
  
    nextDate.setDate(date.getDate() + 1);
    prevDate.setDate(date.getDate() - 1);

    setCurrentDate(date);
    setOptions([
      {
        label: formatDate(`${convertDateToStringWithoutTime(prevDate)}T00:00:00`, true),
        value: prevDate,
      },
      {
        label: formatDate(`${convertDateToStringWithoutTime(date)}T00:00:00`, true),
        value: date,
      },
      {
        label: formatDate(`${convertDateToStringWithoutTime(nextDate)}T00:00:00`, true),
        value: nextDate,
      },
    ]);
    onValueChange(date);
  }
  if (options && currentDate) {

    return (
      <div className="inline-flex flex-row bg-secondary-700 rounded-lg items-center justify-center p-1 h-11">
        <div className="flex w-full">
          <Button
            className={`text-title-medium normal-case py-2 px-4 h-9 rounded-[8px] bg-transparent ease-in-out duration-200 data-[state=active]:bg-white hover:bg-white/50 min-w-[108px] text-center !justify-center ${block ? "w-full" : "w-auto"}`}
            onClick={() => changeDate(options[0].value)}
          >
            {options[0].label}
          </Button>
          <Button
            data-state="active"
            className={`text-title-medium normal-case py-2 px-4 h-9 rounded-[8px] bg-transparent ease-in-out duration-200 data-[state=active]:bg-white hover:bg-white/50 min-w-[108px] text-center !justify-center ${block ? "w-full" : "w-auto"}`}
            onClick={() => changeDate(options[1].value)}
          >
            {options[1].label}
          </Button>
          <Button
            className={`text-title-medium normal-case py-2 px-4 h-9 rounded-[8px] bg-transparent ease-in-out duration-200 data-[state=active]:bg-white hover:bg-white/50 min-w-[108px] text-center !justify-center ${block ? "w-full" : "w-auto"}`}
            onClick={() => changeDate(options[2].value)}
          >
            {options[2].label}
          </Button>
        </div>
      </div>
    );
  }
}
